<template>
  <div>
    <div v-if="!item" class="example3">
      <a-spin />
    </div>
    <fo-layout v-else>
      <div class="cases-dtl">
        <div>
          <p class="pages-return-btn">
            <span @click="$router.push('/practice/cases')"><a-icon type="left" /> 返回</span>
          </p>
        </div>
        <a-row :gutter="50">
          <a-col :sm="16">
            <h1 class="page-title">{{item.case_title}}</h1>
          </a-col>
        </a-row>
        <a-row :gutter="50">
          <a-col :sm="16">
            <div class="subtitle down-solid">
              <span>行业分类: {{item.case_industry_title_zh || '-'}}</span>
              <span>业务类型: {{item.case_business_title_zh || '-'}}</span>
            </div>
            <div class="content-html" v-html="item.case_content"></div>
          </a-col>
          <a-col :sm="8">
            <div class="down-solid casesmore-title">
              <div class="silver ta-c">相关案例</div>
            </div>
            <fo-nodata v-if="!casesData.length"></fo-nodata>
            <template v-for="(casesItem, ind) in casesData">
              <div class="mt-30" :key="ind" v-if="ind < 3">
                <cardCase
                  :imgurl="casesItem.case_poster_url"
                  :title="casesItem.case_title"
                  :industries="casesItem.case_industry_title_zh"
                  :areas="casesItem.case_business_title_zh"
                  @click="$router.push('../cases/' + casesItem.code)">
                </cardCase>
              </div>
            </template>
          </a-col>
        </a-row>
      </div>
    </fo-layout>
  </div>
</template>

<script>
import cardCase from './comps/cardCases.vue'
export default {
  components: {
    cardCase
  },
  data () {
    return {
      casesData: [], // 案列列表
      item: {},
      cond: {
        page_num: '1',
        page_size: '4',
        case_industry_id: ''
      }
    }
  },
  mounted () {
    this.readDtl()
  },
  watch: {
    '$route.params.param' () {
      this.readDtl()
    }
  },
  methods: {
    readList () {
      this.loading = true
      this.get({
        url: 'casesRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        this.casesData = res.data.items.filter(item => item.code !== this.$route.params.param)
      })
    },
    readDtl () {
      this.get({
        url: 'casesFind',
        data: {
          code: this.$route.params.param
        }
      }, (res) => {
        this.item = res.data
        this.cond.case_industry_id = res.data.case_industry_id
        this.readList()
      })
    }
  }
}
</script>

<style lang="less">
@import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .cases-dtl {
    .page-title {
      font-weight: bold;
      font-family: Georgia, 宋体;
      margin-bottom: 20px;
    }
    .subtitle {
      margin-bottom: 30px;
      span {
        margin-right: 20px;
      }
    }
    .down-solid {
      width: 100%;
      border-bottom: 1px solid @graydark;
      padding-bottom: 20px;
      font-size: 16px;
    }
    .casesmore-title {
      margin-top: 30px;
      div {
        text-align: left;
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .cases-dtl {
    .page-title {
      font-weight: bold;
      font-family: Georgia, 宋体;
      margin-bottom: 20px;
    }
    .subtitle {
      margin-bottom: 30px;
      span {
        margin-right: 20px;
      }
    }
    .down-solid {
      width: 100%;
      border-bottom: 1px solid @graydark;
      height: 40px;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/casesDtl.vue